<template>
  <v-app>
    <RouterView />
    <SessionExpiredModal />
  </v-app>
</template>

<script setup lang="ts">
import { onMounted } from 'vue'
import { RouterView } from 'vue-router'
import { useEnterpriseTheme } from '@/composables/useEnterpriseTheme'
import SessionExpiredModal from '@/components/SessionExpiredModal.vue'

// Apply stored enterprise theme (Vuetify + CSS variables) once app mounts
const { themeId, setTheme } = useEnterpriseTheme()
onMounted(() => setTheme(themeId.value))
</script>
